import { useCallback, useEffect } from 'react';
import { IBonusConfig } from 'js/components/system/App/store/types';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const PROMOTION_SHOWN = 'PROMOTION_SHOWN';

export const useOnPromotionShown = (eventTarget: EventTarget): void => {
    const triggerPromotionOptInEvent = useCallback((detail: {
        bonus: IBonusConfig;
    }) => {
        const event = new CustomEvent(PROMOTION_SHOWN, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('promotion-shown', triggerPromotionOptInEvent);

        return () => {
            publicEventsAPIService.off('promotion-shown', triggerPromotionOptInEvent);
        };
    }, [triggerPromotionOptInEvent]);
};
